import React from "react"
import { cn } from "../utils"

export type NoteActionsProps = {
  children: React.ReactNode
  className?: string
}

export function NoteActions({ children, className }: NoteActionsProps) {
  return (
    <div
      className={cn(
        "[grid-area:actions] flex flex-wrap items-center gap-2",
        className
      )}
      data-slot="note-actions"
    >
      {children}
    </div>
  )
}
